export default "__VITE_ASSET__D$g1T7bT__"